import Repository from './Repository';

const resource = "/users";
export default {
    all(limit=10000) {
        return Repository.get(`${resource}/?limit=${limit}`);
    },
    ids(list) {
        return Repository.get(`${resource}/?ids=${list}`);
    },
    get(id) {
        return Repository.get(`${resource}/${id}/`);
    },
    post(data) {
        return Repository.post(`${resource}/`, data);
    },
    patch(data) {
        return Repository.patch(`${resource}/`, data);
    },
    page(page, limit=10, search='') {
        var offset = (page - 1) * limit
        if(search) { search = `&search=${search}` }
        return Repository.get(`${resource}/?limit=${limit}&offset=${offset}${search}`);
    },
    query(params) {
        if(params.limit == undefined) params.limit = 50
        if(params.page == undefined) params.page = 1

        params.offset = (params.page - 1) * params.limit
        params = new URLSearchParams(params).toString()
        return Repository.get(`${resource}/?${params}`)
    },
    profile(id) {
        return Repository.get(`${resource}/profiles/${id}`);
    },
    // delete(id) {
    //     return Repository.delete(`${resource}/${id}/`);
    // }
}